import angular from "angular";
import Results from "./results/results";
import Dashboard from "./dashboard/dashboard";
/* Reports */
import Reports from "./reports/reports";
/* Auth */
import Login from "./auth/login/login";
import Recover from "./auth/recover/recover";
import Reset from "./auth/reset/reset";
/* Users */
import Users from "./users/users";
/* Payments */
import PaymentsList from "./payments/paymentsList/paymentsList";
import PaymentsTeam from "./payments/paymentsTeam/paymentsTeam";
import PaymentsPlayer from "./payments/paymentsPlayer/paymentsPlayer";
import PaymentsTeamList from "./payments/paymentsPlayerList/paymentsPlayerList";
import PaymentsPlayerList from "./payments/paymentsTeamList/paymentsTeamList";
/* Matches */
import MatchesList from "./matches/matchesList/matchesList";
import MatchProfile from "./matches/matchProfile/matchProfile";
import MatchTargets from "./matches/matchProfile/matchTargets/matchTargets";
import MatchLeagues from "./matches/matchProfile/matchLeagues/matchLeagues";
import MatchPrints from "./matches/matchProfile/matchPrints/matchPrints";
import MatchEliminations from "./matches/matchProfile/matchEliminations/matchEliminations";
import MatchFinalize from "./matches/matchProfile/matchFinalize/matchFinalize";
import MatchRegistrations from "./matches/matchProfile/matchRegistrations/matchRegistrations";
import MatchAddShots from "./matches/matchProfile/matchAddShots/matchAddShots";
import MatchAddShotsVisual from "./matches/matchProfile/matchAddShotsVisual/matchAddShotsVisual";
import MatchAddShotsIndividual from "./matches/matchProfile/matchAddShotsIndividual/matchAddShotsIndividual";
import MatchShotsIndividualVisual from "./matches/matchProfile/matchShotsIndividualVisual/matchShotsIndividualVisual";
import MatchAddShotsTeam from "./matches/matchProfile/matchAddShotsTeam/matchAddShotsTeam";
import MatchAddShotsMixedTeam from "./matches/matchProfile/matchAddShotsMixedTeam/matchAddShotsMixedTeam";
import MatchEdit from "./matches/matchEdit/matchEdit";
/* Leagues */
import Leagues from "./leagues/leagues";
/* Roles */
import Roles from "./roles/roles";
/* Transfers */
import Transfers from "./transfers/transfers";
/* Teams */
import TeamsList from "./teams/teamsList/teamsList";
import TeamProfile from "./teams/teamProfile/teamProfile";
import TeamEdit from "./teams/teamEdit/teamEdit";
/* Judges */
import JudgesList from "./judges/judgesList/judgesList";
import JudgeEdit from "./judges/judgeEdit/judgeEdit";
import JudgeProfile from "./judges/judgeProfile/judgeProfile";
/* Coaches */
import CoachesList from "./coaches/coachesList/coachesList";
import CoachEdit from "./coaches/coachEdit/coachEdit";
import CoachProfile from "./coaches/coachProfile/coachProfile";
/* Staff */
import StaffList from "./staff/staffList/staffList";
import StaffEdit from "./staff/staffEdit/staffEdit";
import StaffProfile from "./staff/staffProfile/staffProfile";
/* Trainers */
import TrainersList from "./trainers/trainersList/trainersList";
import TrainerEdit from "./trainers/trainerEdit/trainerEdit";
import TrainerProfile from "./trainers/trainerProfile/trainerProfile";
/* Players */
import PlayersList from "./players/playersList/playersList";
import PlayerEdit from "./players/playerEdit/playerEdit";
import PlayerProfile from "./players/playerProfile/playerProfile";
import PlayerInfo from "./players/playerProfile/playerInfo/playerInfo";
import PlayerMatches from "./players/playerProfile/playerMatches/playerMatches";
import PlayerPassports from "./players/playerProfile/playerPassports/playerPassports";
import PlayerPayments from "./players/playerProfile/playerPayments/playerPayments";
import PlayerTransfers from "./players/playerProfile/playerTransfers/playerTransfers";
import PlayerTrainingEntries from "./players/playerProfile/playerTrainingEntries/playerTrainingEntries";
/* Training Center*/
import TrainingCenter from "./trainingCenter/trainingCenter";
import TrainingCentersList from "./trainingCenters/trainingCentersList/trainingCentersList";
import TrainingCenterEdit from "./trainingCenters/trainingCenterEdit/trainingCenterEdit";
import TrainingCenterProfile from "./trainingCenters/trainingCenterProfile/trainingCenterProfile";
import Privacy from "./privacy/privacy";

let componentModule = angular.module("app.components", [
  Reports,
  Results,
  Dashboard,
  Login,
  Recover,
  Reset,
  Users,
  PaymentsList,
  PaymentsTeam,
  PaymentsTeamList,
  PaymentsPlayer,
  PaymentsPlayerList,
  MatchesList,
  MatchTargets,
  MatchLeagues,
  MatchPrints,
  MatchEdit,
  MatchProfile,
  MatchEliminations,
  MatchFinalize,
  MatchRegistrations,
  MatchAddShotsVisual,
  MatchAddShots,
  MatchAddShotsIndividual,
  MatchAddShotsTeam,
  MatchAddShotsMixedTeam,
  MatchShotsIndividualVisual,
  Leagues,
  Roles,
  Transfers,
  TeamsList,
  TeamProfile,
  TeamEdit,
  CoachesList,
  CoachProfile,
  CoachEdit,
  JudgesList,
  JudgeEdit,
  JudgeProfile,
  TrainersList,
  TrainerEdit,
  TrainerProfile,
  PlayersList,
  PlayerEdit,
  PlayerProfile,
  PlayerInfo,
  PlayerMatches,
  PlayerPassports,
  PlayerPayments,
  PlayerTransfers,
  PlayerTrainingEntries,
  TrainingCenter,
  StaffList,
  StaffEdit,
  StaffProfile,
  TrainingCentersList,
  TrainingCenterEdit,
  TrainingCenterProfile,
  Privacy,
]).name;

export default componentModule;



// WEBPACK FOOTER //
// ./client/app/components/components.js